export class GetFederatedTokenModel {
    AuthCode: string;
    idp: string;
  }
  